import React from "react";
import { Form } from "react-bootstrap";

const InputLabel = ({ meta }) => {
  return <Form.Label>{meta?.labelText}</Form.Label>;
};

export default InputLabel;
